<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-button :to="{name: 'service-list', params: {save: true}}" size="sm" variant="link"><i class="fa fa-chevron-left" /></b-button>
        模板编辑
      </div>
      <b-form v-if="showEdit" @submit="onSubmit" @reset="onReset">
        <b-form-group label="实例信息" label-for="desc">
          <b-card>
            <JsonView
              :parsedData="descData"
              v-model="descData"
            />
          </b-card>
        </b-form-group>
        <b-form-group label="创建实例参数配置" label-for="create">
          <b-card>
            <JsonView
              :parsedData="createdData"
              v-model="createdData"
            />
          </b-card>
        </b-form-group>
        <b-form-group label="实例配置" label-for="confs">
          <b-card>
            <JsonView
              :parsedData="confsData"
              v-model="confsData"
            />
          </b-card>
        </b-form-group>
        <b-form-group label="接口信息配置" label-for="desc">
          <b-form-checkbox v-model="hasInterfaces" switch />
          <b-card v-if="hasInterfaces">
            <b-form-group label="接口配置">
              <b-link @click="addRoot(interfacesUrls)"><i class="fa fa-plus" /></b-link>
              <div class="url-structure">
                <template v-for="(item, index) in interfacesUrls">
                  <UrlStructure :key="interfacesUrls.length.toString() + index.toString()" :urlItem="item" :parent="interfacesUrls" @del="del" />
                </template>
              </div>
            </b-form-group>
            <b-form-group label="参数配置">
              <Tab v-if="data.interfaces && Object.keys(data.interfaces).length > 0 && interfacesShow" :items.sync="data.interfaces" />
            </b-form-group>
          </b-card>
        </b-form-group>
        <b-form-group label="统计接口配置" label-for="desc">
          <b-form-checkbox v-model="hasStat" switch />
          <b-card v-if="hasStat">
            <b-form-group label="接口配置">
              <b-link @click="addRoot(statUrls)"><i class="fa fa-plus" /></b-link>
              <div class="url-structure">
                <template v-for="(item, index) in statUrls">
                  <UrlStructure :key="statUrls.length.toString() + index.toString()" :urlItem="item" :parent="statUrls" @del="del" />
                </template>
              </div>
            </b-form-group>
            <b-form-group label="参数配置">
              <Tab v-if="data.stats && Object.keys(data.stats).length > 0 && statShow" :items.sync="data.stats" />
            </b-form-group>
          </b-card>
        </b-form-group>
        <b-form-group label="心跳检查配置" label-for="desc">
          <b-form-checkbox v-model="hasCheck" switch />
          <b-card v-if="hasCheck">
            <b-form-group label="接口配置">
              <b-link @click="addRoot(checkUrls)"><i class="fa fa-plus" /></b-link>
              <div class="url-structure">
                <template v-for="(item, index) in checkUrls">
                  <UrlStructure :key="checkUrls.length.toString() + index.toString()" :urlItem="item" :parent="checkUrls" @del="del" />
                </template>
              </div>
            </b-form-group>
            <b-form-group label="参数配置">
              <Tab v-if="data.checks && Object.keys(data.checks).length > 0 && checkShow" :items.sync="data.checks" />
            </b-form-group>
          </b-card>
        </b-form-group>
        <div slot="footer">
          <b-button type="submit" size="sm" variant="outline-primary"><i class="fa fa-check" /> 提交</b-button>
          <b-button type="reset" size="sm" variant="outline-danger"><i class="fa fa-repeat" /> 复位</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import JsonView from './JsonView.vue'
import UrlStructure from './UrlStructure'
import Tab from './Tab.vue'

export default {
  name: 'template-edit',
  mixins: [Error],
  components: {JsonView, UrlStructure, Tab},
  provide () {
    return {
      formBtnText: this.options
    }
  },
  data () {
    return {
      wrapperType: 'object',
      options: {
        confirmText: '确定',
        cancelText: '取消'
      },
      base_url: '',
      showEdit: true,
      forceDisabled: false,
      hasTimer: false,
      hasInterfaces: false,
      hasStat: false,
      hasCheck: false,
      isUpdate: false,
      reseting: false,
      // desc
      descBaseData: {
        desc: {value: '', desc: '实例描述', type: 'string', isLeafNodeFlag: true, required: true},
        name: {value: '', desc: '实例名称', type: 'string', isLeafNodeFlag: true, required: true},
        url: {value: '', desc: '接口地址', type: 'string', isLeafNodeFlag: true, banOp: true, required: true}
      },
      descStaticData: null,
      descData: [],
      lastDescData: {},
      // create
      createdBaseData: {
        SECRET_KEY: {value: '', desc: '密钥', type: 'string', re: '^[\\w\\W]{0,32}$', isLeafNodeFlag: true, banOp: true, required: true}
      },
      createdStaticData: null,
      createdData: [],
      lastCreatedData: {},
      // confs
      confsBaseData: {},
      confsStaticData: null,
      confsData: [],
      lastConfsData: {},
      // interfaces
      interfacesUrls: [],
      interfacesStaticUrls: null,
      interfacesBaseData: {
        desc: '',
        isopen: null,
        param: [],
        return_type: 'JSON',
        data_tag: '',
        table_conf: [],
        sign_check: false
      },
      interfacesStaticData: {},
      interfacesShow: true,
      // stat
      statUrls: [],
      statStaticUrls: null,
      statBaseData: {
        desc: '',
        isopen: null,
        param: [],
        timer: {second: '', minute: '', hour: '', day: '', month: '', year: '', week: '', day_of_week: '', start_date: '', end_date: '', timezone: 'Asia/Shanghai'},
        tag_desc: []
      },
      statStaticData: {},
      statShow: true,
      // check
      checkUrls: [],
      checkStaticUrls: null,
      checkBaseData: {
        desc: '',
        isopen: null,
        param: [],
        timer: {second: '', minute: '', hour: '', day: '', month: '', year: '', week: '', day_of_week: '', start_date: '', end_date: '', timezone: 'Asia/Shanghai'}
      },
      checkStaticData: {},
      checkShow: true,

      data: null,
      submitData: {
        descs: {},
        create: {},
        confs: {},
        interfaces: {},
        stats: {},
        checks: {}
      }
    }
  },
  created () {
    this.getTemplate()
  },
  watch: {
    // create
    createdBaseData: {
      handler (newValue, oldValue) {
        this.createdData = this.jsonParse(this.createdBaseData)
      }
    },
    createdData: {
      handler (newValue, oldValue) {
        if (JSON.stringify(newValue) === JSON.stringify(this.lastCreatedData)) {
          return
        }
        this.lastCreatedData = JSON.parse(JSON.stringify(newValue))
        this.submitData.create = this.makeJson(this.createdData)
      },
      deep: true
    },
    // confs
    confsBaseData: {
      handler (newValue, oldValue) {
        this.confsData = this.jsonParse(this.confsBaseData)
      }
    },
    confsData: {
      handler (newValue, oldValue) {
        if (JSON.stringify(newValue) === JSON.stringify(this.lastConfsData)) {
          return
        }
        this.lastConfsData = JSON.parse(JSON.stringify(newValue))
        this.submitData.confs = this.makeJson(this.confsData)
      },
      deep: true
    },
    // desc
    descBaseData: {
      handler (newValue, oldValue) {
        this.descData = this.jsonParse(this.descBaseData)
      }
    },
    descData: {
      handler (newValue, oldValue) {
        if (JSON.stringify(newValue) === JSON.stringify(this.lastDescData)) {
          return
        }
        this.lastDescData = JSON.parse(JSON.stringify(newValue))
        this.submitData.descs = this.makeJson(this.descData)
      },
      deep: true
    },
    // interface url
    interfacesUrls: {
      handler (newValue, oldValue) {
        this.interfacesShow = false
        let tmpData = this.reseting ? this.interfacesStaticData : this.data.interfaces
        this.data.interfaces = this.getUrlData(this.interfacesUrls, tmpData, this.interfacesBaseData)
        this.$nextTick(() => {
          this.interfacesShow = true
        })
      },
      deep: true
    },
    // stat url
    statUrls: {
      handler (newValue, oldValue) {
        this.statShow = false
        let tmpData = this.reseting ? this.statStaticData : this.data.stats
        this.data.stats = this.getUrlData(this.statUrls, tmpData, this.statBaseData)
        this.$nextTick(() => {
          this.statShow = true
        })
      },
      deep: true
    },
    // check url
    checkUrls: {
      handler (newValue, oldValue) {
        this.checkShow = false
        let tmpData = this.reseting ? this.checkStaticData : this.data.checks
        this.data.checks = this.getUrlData(this.checkUrls, tmpData, this.checkBaseData)
        this.$nextTick(() => {
          this.checkShow = true
        })
      },
      deep: true
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      this.submitData.interfaces = this.hasInterfaces ? this.makeParamJson(this.data.interfaces) : {}
      this.submitData.stats = this.hasStat ? this.makeParamJson(this.data.stats) : {}
      this.submitData.checks = this.hasCheck ? this.makeParamJson(this.data.checks) : {}

      this.submitData.interface_update = !this.isEqual(this.data.interfaces, this.interfacesStaticData)
      this.submitData.stat_update = !this.isEqual(this.data.stats, this.statStaticData)
      this.submitData.check_update = !this.isEqual(this.data.checks, this.checkStaticData)
      if (this.isUpdate) {
        api.updateData(this, api.getTemplateUpdate(this.$route.params.serviceCode), this.submitData, this.backAfterUpdate)
      } else {
        api.createData(this, api.getTemplateCreate(this.$route.params.serviceCode), this.submitData, 'service-list')
      }
    },
    onReset (evt) {
      evt.preventDefault()
      this.showEdit = false
      this.reseting = true
      this.descBaseData = JSON.parse(JSON.stringify(this.descStaticData))
      this.createdBaseData = JSON.parse(JSON.stringify(this.createdStaticData))
      this.confsBaseData = JSON.parse(JSON.stringify(this.confsStaticData))
      this.interfacesUrls = JSON.parse(JSON.stringify(this.interfacesStaticUrls))
      this.statUrls = JSON.parse(JSON.stringify(this.statStaticUrls))
      this.checkUrls = JSON.parse(JSON.stringify(this.checkStaticUrls))
      this.$nextTick(() => {
        this.showEdit = true
        this.reseting = false
      })
    },
    getTemplate () {
      api.detailData(this, api.getTemplateDetail(this.$route.params.serviceCode), 'template_info', null, this.getTemplateCallback)
    },
    getTemplateCallback () {
      if (this.data.descs) {
        this.descBaseData = this.data.descs
        this.isUpdate = true
      }
      if (this.data.create) {
        this.createdBaseData = this.data.create
        this.isUpdate = true
      }
      if (this.data.confs) {
        this.confsBaseData = this.data.confs
        this.isUpdate = true
      }
      if (this.data.interfaces && Object.keys(this.data.interfaces).length > 0) {
        this.interfacesUrls = []
        this.getUrls(this.interfacesUrls, this.data.interfaces)
        this.isUpdate = true
        this.hasInterfaces = true
      }
      if (this.data.stats && Object.keys(this.data.stats).length > 0) {
        this.statUrls = []
        this.getUrls(this.statUrls, this.data.stats)
        this.isUpdate = true
        this.hasStat = true
      }
      if (this.data.checks && Object.keys(this.data.checks).length > 0) {
        this.checkUrls = []
        this.getUrls(this.checkUrls, this.data.checks)
        this.isUpdate = true
        this.hasCheck = true
      }
      this.descStaticData = JSON.parse(JSON.stringify(this.descBaseData))
      this.createdStaticData = JSON.parse(JSON.stringify(this.createdBaseData))
      this.confsStaticData = JSON.parse(JSON.stringify(this.confsBaseData))
      this.interfacesStaticData = this.data.interfaces ? JSON.parse(JSON.stringify(this.data.interfaces)) : {}
      this.statStaticData = this.data.stats ? JSON.parse(JSON.stringify(this.data.stats)) : {}
      this.checkStaticData = this.data.checks ? JSON.parse(JSON.stringify(this.data.checks)) : {}

      this.interfacesStaticUrls = JSON.parse(JSON.stringify(this.interfacesUrls))
      this.statStaticUrls = JSON.parse(JSON.stringify(this.statUrls))
      this.checkStaticUrls = JSON.parse(JSON.stringify(this.checkUrls))

      this.descData = this.jsonParse(this.descBaseData)
      this.createdData = this.jsonParse(this.createdBaseData)
      this.confsData = this.jsonParse(this.confsBaseData)
    },
    backAfterUpdate () {
      this.$router.push({name: 'service-list'})
    },
    jsonParse (jsonStr) {
      const parseJson = json => {
        let result = []
        let keys = Object.keys(json)
        keys.forEach((k, index) => {
          let val = json[k]
          let parsedVal = val
          let curType = ''
          if (this.getType(val) === 'object' && !val.isLeafNodeFlag) {
            parsedVal = parseJson(val)
            curType = this.getType(val)
          } else if (this.getType(val) === 'array') {
            parsedVal = parseArray(val)
            curType = this.getType(val)
          } else {
            curType = val.type
          }
          let opt = {
            name: k,
            type: curType,
            banOp: val.banOp,
            disabled: val.disabled,
            placeholder: val.placeholder,
            required: val.required
          }
          if (opt.type === 'array' || opt.type === 'object') {
            opt.childParams = parsedVal
            opt.remark = null
          } else {
            opt.childParams = null
            opt.remark = parsedVal.value
            opt.desc = parsedVal.desc
            if (opt.type !== 'boolean') {
              if (opt.type === 'datetime') {
                opt.range = parsedVal.range | ['', '']
              } else {
                opt.re = parsedVal.re
              }
            }
          }
          result.push(opt)
        })
        return result
      }
      //
      const parseArray = arrayObj => {
        let result = []
        for (let i = 0; i < arrayObj.length; ++i) {
          let val = arrayObj[i]
          let parsedVal = val
          let curType = ''
          if (this.getType(val) === 'object' && !val.isLeafNodeFlag) {
            parsedVal = parseJson(val)
            curType = this.getType(val)
          } else if (this.getType(val) === 'array') {
            parsedVal = parseArray(val)
            curType = this.getType(val)
          } else {
            curType = val.type
          }
          let opt = {
            name: null,
            type: curType,
            banOp: val.banOp,
            disabled: val.disabled,
            placeholder: val.placeholder,
            required: val.required
          }
          if (opt.type === 'array' || opt.type === 'object') {
            opt.childParams = parsedVal
            opt.remark = null
          } else {
            opt.childParams = null
            opt.remark = parsedVal.value
            opt.desc = parsedVal.desc
            if (opt.type !== 'boolean') {
              if (opt.type === 'datetime') {
                opt.range = parsedVal.range ? parsedVal.range : ['', '']
              } else {
                opt.re = parsedVal.re
              }
            }
          }
          result.push(opt)
        }
        return result
      }
      // --
      const parseBody = data => {
        let r = null
        switch (this.getType(data)) {
          case 'array':
            this.wrapperType = 'array'
            r = parseArray(data)
            break
          case 'object':
            this.wrapperType = 'object'
            r = parseJson(data)
            break
        }
        return r
      }
      return parseBody(jsonStr)
    },
    getType (obj) {
      switch (Object.prototype.toString.call(obj)) {
        case '[object Array]':
          return 'array'
        case '[object Object]':
          return obj.isLeafNodeFlag ? this.getType(obj.value) : 'object'
        case '[object Null]':
        case '[object Function]':
        case '[object Undefined]':
          return 'string'
        default:
          return typeof obj === 'number' ? 'int' : typeof obj
      }
    },
    makeJson (dataArr) {
      const revertWithObj = data => {
        let r = {}
        for (let i = 0; i < data.length; ++i) {
          let el = data[i]
          let key, val
          key = el.name
          if (el.type === 'array') {
            val = revertWithArray(el.childParams)
          } else if (el.type === 'object') {
            val = revertWithObj(el.childParams)
          } else {
            val = {
              value: el.remark,
              type: el.type,
              desc: el.desc,
              isLeafNodeFlag: true,
              banOp: el.banOp,
              required: el.required
            }
            if (el.type !== 'boolean') {
              if (el.type === 'datetime') {
                val.range = el.range
              } else {
                val.re = el.re
              }
            }
          }
          r[key] = val
        }
        return r
      }
      const revertWithArray = data => {
        let arr = []
        for (let i = 0; i < data.length; ++i) {
          let el = data[i]
          let r
          if (el.type === 'array') {
            r = revertWithArray(el.childParams)
          } else if (el.type === 'object') {
            r = revertWithObj(el.childParams)
          } else {
            r = {
              value: el.remark,
              type: el.type,
              desc: el.desc,
              isLeafNodeFlag: true,
              banOp: el.banOp,
              required: el.required
            }
            if (el.type !== 'boolean') {
              if (el.type === 'datetime') {
                r.range = el.range
              } else {
                r.re = el.re
              }
            }
          }
          arr.push(r)
        }
        return arr
      }
      const revertMain = data => {
        let r = null
        switch (this.wrapperType) {
          case 'array':

            r = revertWithArray(data)
            break
          case 'object':
            r = revertWithObj(data)
            break
        }
        return r
      }
      return revertMain(dataArr)
    },
    addRoot (rootList) {
      rootList.push({name: '', child: []})
    },
    del (data) {
      for (let idx in data.parent) {
        if (data.parent[idx].name === data.name) {
          data.parent.splice(idx, 1)
          break
        }
      }
    },
    getUrls (urls, data) {
      for (let key in data) {
        urls.push({name: key, child: []})
        if (!data[key].hasOwnProperty('param')) {
          this.getUrls(urls[urls.length - 1].child, data[key])
        }
      }
    },
    getUrlData (dataArr, lastData, baseData) {
      const revertWithObj = (data, lastData) => {
        let r = {}
        for (let i = 0; i < data.length; ++i) {
          let el = data[i]
          let key, val
          key = el.name
          if (el.child && el.child.length > 0) {
            val = revertWithObj(el.child, (lastData && lastData.hasOwnProperty(key)) ? lastData[key] : null)
          } else {
            val = (lastData && lastData.hasOwnProperty(key) && lastData[key].hasOwnProperty('param')) ? JSON.parse(JSON.stringify(lastData[key])) : JSON.parse(JSON.stringify(baseData))
            if (Object.prototype.toString.call(val.param) === '[object Object]') {
              val.param = this.jsonParse(val.param)
            }
          }
          r[key] = val
        }
        return r
      }
      const revertMain = (data, lastData) => {
        let r = null
        r = revertWithObj(data, lastData)
        return r
      }
      return revertMain(dataArr, lastData)
    },
    makeParamJson (data) {
      if (Object.prototype.toString.call(data) === '[object Object]') {
        let r = {}
        for (let key in data) {
          if (key === 'param' && data[key] instanceof Array) {
            r[key] = this.makeJson(data[key])
          } else {
            r[key] = this.makeParamJson(data[key])
          }
        }
        return r
      } else {
        return data
      }
    },
    isEqual (objA, objB) {
      // 相等
      if (objA === objB) return objA !== 0 || 1 / objA === 1 / objB
      // 空判断
      if (objA == null || objB == null) return objA === objB
      // 类型判断
      if (Object.prototype.toString.call(objA) !== Object.prototype.toString.call(objB)) return false

      switch (Object.prototype.toString.call(objA)) {
        case '[object RegExp]':
        case '[object String]':
          // 字符串转换比较
          return '' + objA === '' + objB
        case '[object Number]':
          // 数字转换比较,判断是否为NaN
          if (+objA !== +objA) {
            return +objB !== +objB
          }
          return +objA === 0 ? 1 / +objA === 1 / objB : +objA === +objB
        case '[object Date]':
        case '[object Boolean]':
          return +objA === +objB
        case '[object Array]':
          // 判断数组
          for (let i = 0; i < objA.length; i++) {
            if (!this.isEqual(objA[i], objB[i])) return false
          }
          return true
        case '[object Object]':
          // 判断对象
          let keys = Object.keys(objA)
          for (let i = 0; i < keys.length; i++) {
            if (!this.isEqual(objA[keys[i]], objB[keys[i]])) return false
          }
          keys = Object.keys(objB)
          for (let i = 0; i < keys.length; i++) {
            if (!this.isEqual(objA[keys[i]], objB[keys[i]])) return false
          }
          return true
        default:
          return false
      }
    }
  }
}
</script>

<style>
  .desc-input {
    width: 20%;
  }
  .url-structure {
    padding: 0 15px;
  }
  .block.clearfix:hover, .array-item:hover {
    background: #dfdfdf63;
  }
</style>



// WEBPACK FOOTER //
// TemplateEdit.vue?6c0733bd